/**
 * MapPicker (#678) — a small, controlled select for choosing the wire
 * `mapSlug` override `createMatch` accepts (seat-0-only; see
 * `CLIENT_CREATE_MATCH_SCHEMA`'s doc comment). Mirrors `ModePicker`'s shape.
 *
 * Sourced from `ALL_CONTENT_MAPS` (`render/arenaCatalog.ts`) — the SAME
 * build-time content-glob catalog the live-match renderer reads, not a
 * hand-maintained list, so a new map appears here automatically. This list
 * is display-only; the server independently resolves (and rejects an
 * unknown) slug via `@pit/content`'s `mapBySlug`.
 */

import type { ReactElement } from "react";
import { ALL_CONTENT_MAPS } from "../render/arenaCatalog.js";

export interface MapPickerProps {
  readonly value: string;
  readonly onChange: (slug: string) => void;
  readonly disabled?: boolean;
}

export function MapPicker({ value, onChange, disabled = false }: MapPickerProps): ReactElement {
  return (
    <label
      data-testid="map-picker"
      style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14 }}
    >
      <span style={{ opacity: 0.75 }}>Map</span>
      <select
        data-testid="map-select"
        value={value}
        disabled={disabled}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        style={{
          padding: "6px 10px",
          fontSize: 14,
          borderRadius: 4,
          border: "1px solid #3a4757",
          background: "#161c24",
          color: "#dfe6ef",
        }}
      >
        {ALL_CONTENT_MAPS.map((m) => (
          <option key={m.slug} value={m.slug}>
            {m.slug}
          </option>
        ))}
      </select>
    </label>
  );
}
